export const cn = (...args) => {
  return args.filter(arg => !!arg).join(" ");
};
